module.exports = __webpack_public_path__ + "static/pB7-e628c025d855c23a5cda4f06b8ca2cbf.png";